import { authService } from '../_services'

const emptyState = {
  authenticated: false,
  profile: {
    role: 'None'
  }
}

function stateFromLocalStorage() {
  let profile = JSON.parse(localStorage.getItem('profile'))
  // console.log('the profile -> ' + profile)
  if (profile) {
    // console.log('profile is there')
    return {
      authenticated: true,
      profile: profile
    }
  } else {
    // console.log('profile is not here')
    return emptyState
  }
}

const state = stateFromLocalStorage()

const getters = {
  getAuthenticated: (state) => {
    state.authenticated
  },
  // getProfile: (state) => {
  //   state.profile 
  // },
  getName: (state) => {
    if (state.profile.role !== 'None') {
      return state.profile.name
    }
    return 'NO_USER'
  },
  getIsAdminHQ: (state) => {
    if (state.profile.role === 'AdminHQ') {
      return true
    }
    return false
  },
  getIsSupportHQ: (state) => {
    if (state.profile.role === 'SupportHQ') {
      return true
    }
    return false
  },
  getIsHQView: (state) => {
    if (state.profile.role === 'HQView') {
      return true
    }
    return false
  },
  getIsTeamLeader: (state) => {
    if (state.profile.role === 'TeamLeader') {
      return true
    }
    return false
  },
  getIsFieldWorker: (state) => {
    if (state.profile.role === 'FieldWorker') {
      return true
    }
    return false
  },
}

const actions = {
  authenticateUser: (context, userProfile) => {
    console.log('action: authenticateUser')
    context.commit('AUTHENTICATE_USER', userProfile)
  },
  deauthenticateUser: (context) => {
    console.log('action: deauthenticateUser')
    context.commit('DEAUTHENTICATE_USER')
    authService.logout()
    .then(response => {
      console.log("logged out on backend")
    })
  },
  // ping: (context) => {
  //   authService.ping()
  //   .then(
  //     response => {
  //       console.log('ping success')
  //       console.log(response)
  //     },
  //     error => error
  //   )
  // }
}

const mutations = {
  AUTHENTICATE_USER: (state, userProfile) => {
    console.log('mutation: AUTHENTICATE_USER')
    localStorage.setItem('profile', JSON.stringify(userProfile))
    state.profile = userProfile
    state.authenticated = true
  },
  DEAUTHENTICATE_USER: (state) => {
    console.log('mutation: DEAUTHENTICATE_USER')
    localStorage.removeItem('profile')
    state.profile = {role: 'None'}
    state.authenticated = false
  }
}

export const auth = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/_store/auth.module.js